import { axios } from './config';

// 研判列表-获取列表
export function getYpList(params) {
  return axios.get(`/researchvote/list_all`, params, true);
}

// 研判列表审核
export function examineYp(params) {
  return axios.post('/researchvote/audit', params, true);
}

// 研判列表详情
export function examinInfo(params) {
  return axios.get(`/researchvote/info/${params}`, params, true)
}

// 研判列表-删除
// export function delYpList(params) {
//   return axios('/researchvote/delete', params, 'post');
// }

// 研判列表-预览（承诺公告）(其实是获取列表的第一条数据)
// export function getListFirst() {
//   return axios('/researchvote/first', 'get');
// }

// 获取巡检点
export function getHiddendangerPointList(params) {
  return axios.get('/hiddendanger/list_all', params, false);
}

// 获取风险点
export function getRiskPointList(params) {
  return axios.get('/riskclassification/list_all', params, false);
}

// 风险点新增
export function riskPointAdd(params) {
  return axios.post('/riskclassification/save', params, false);
}

// 风险点详情
export function riskPointDetail(params) {
  return axios.get(`/riskclassification/info/${params}`, true);
}

// 风险点详情里面的 (管控，辨识)列表数据
export function riskPointDetailListData(params) {
  return axios.get(`/riskclassification/findRiskControllerAndIdentify/${params}`, true)
}

// 风险点详情里面  排查记录数据
export function riskPointPClist(params) {
  return axios.post(`/riskclassification/getTroubleshootTask/`, params, true)
}

// 风险点详情里面  巡检记录数据
export function riskPointXJlist(params) {
  return axios.post('/riskclassification/findRiskPointInspectionRecord', params, true)
}

// 风险点编辑
export function riskPointUpdate(params) {
  return axios.post('/riskclassification/update', params, false);
}

// 风险点更新危险因素
export function riskPointupdateRiskFactorId(params) {
  return axios.post('/riskclassification/updateRiskFactorId', params, false);
}

// 风险点删除
export function riskPointDelete(params) {
  return axios.delete(`/riskclassification/delete/${params}`, true)
}


// 获取风险点危险因素
export function getRiskFactorList(params) {
  return axios.get('/riskFactor/list', params, false);
}
// 风险点新增
export function riskFactorAdd(params) {
  return axios.post('/riskFactor/save', params, false);
}
// 风险点编辑
export function riskFactorUpdate(params) {
  return axios.post('/riskFactor/update', params, false);
}
// 风险点删除
export function riskFactorDelete(params) {
  return axios.post(`/riskFactor/delete/${params}`, true)
}

// 风险辨识新增
export function riskIdentifyAdd(params) {
  return axios.post('/riskIdentify/save', params, false)
}

// 辨识编辑
export function riskIdentifyEdit(params) {
  return axios.post('/riskIdentify/update', params, false)
}

// 辨识审核
export function riskIdentifyExaminee(params) {
  return axios.post('/riskIdentify/audit', params, true)
}

// 风险辨识列表
export function riskIdentifyList(params) {
  return axios.get('/riskIdentify/list_all', params, true)
}

// 风险辨识删除
export function riskIdentifyDelete(params) {
  return axios.post(`/riskIdentify/delete/${params}`, true)
}

// 风险管控列表
export function riskControlList(params) {
  return axios.get('/riskControl/list_all', params, true)
}

// 通过风险点id 查询辨识列表、危险源列表
export function getIndentifyDangerList(params) {
  return axios.get(`/riskIdentify/findIdentifyAndMeasure/${params}`, true);
}

// 风险管控新增
export function riskControlAdd(params) {
  return axios.post('/riskControl/save', params, false);
}

// 管控编辑
export function riskControlEdit(params) {
  return axios.post('/riskControl/update', params, false);
}

// 管控审核
export function riskControlExaminee(params) {
  return axios.post('/riskControl/audit', params, true);
}

// 风险管控复评
export function riskControlReview(params) {
  return axios.post('/riskControlTracking/save', params, true)
}

// 管控复评列表
export function riskControlReviewList(params) {
  return axios.get('/riskControlTracking/list_all', params, true)
}

// 管控复评删除
export function riskControlReviewDelete(params) {
  return axios.post(`/riskControlTracking/delete/${params}`, true)
}

// 评估详情
export function riskPointAssessment(params) {
  return axios.get(`/riskclassification/getRiskEvaluateJsonStr/${params}`, true);
}

// 风险点评价
export function riskPointEvaluate(params) {
  return axios.post('/riskclassification/saveRiskEvaluateJsonStr', params, false);
}

// 区域风险管理
export function getFxList(params) {
  return axios.get('/areadanger/list_all', params, true);
}

// 区域风险管理
export function getFxListNew(params) {
  return axios.get('/dangerinfo/findAreaRisk', params, false);
}

// 获取区域列表
export function getAreaList(params){
  return axios.get('/dangerinfo/list_all', params, true);
}

// 区域风险管理-搜索
export function searchFxList(params) {
  return axios.get(`/areadanger/queryName/${params}`, true)
}

// 区域风险管理-评价-保存结果(弃用)
// export function saveResult(params) {
//   return axios.post('/areadanger/update', params, true)
// }

// 区域风险管理-评价-保存结果（新）
export function saveResult(params) {
  return axios.post('/dangerinfo/areaRiskEvaluate', params, true)
}

// 区域风险管理-跳转到两单管理
export function jumpTwoOrder(params) {
  return axios.post('/areadanger/querynum', params)
}

// 区域风险管理-从首页扇形图跳转过来
export function withResult(params) {
  return axios.get(`/application/getListByResult/${params}`, true)
}

// 全流程-基础信息管理-模型管理（获取列表）
export function getModelList(params) {
  return axios.get('/model/list_all', params, true)
}

// 全流程-基础信息管理-模型管理（删除）
export function removeModel(params) {
  return axios.delete(`/model/delete/${params}`, true)
}

// 全流程 -基础信息管理-新增模型
export function addModel(params) {
  return axios.post('/model/save', params, true)
}

// 全流程-基础信息管理-编辑模型
export function editModel(params) {
  return axios.post('/model/update', params, true)
}

// 全流程-隐患排查治理-排查任务
export function getRiskPoint(params) {
  return axios.get('/riskclassification/list_all', params, true)
}

// 法律法规 - 列表
export function lawsRegulationsList(params) {
  return axios.get('/lawsRegulations/list_all', params, true)
}

// 全流程-法律法规-辨识和复查
export function lawsRegulationsUpdate(params) {
  return axios.post('/lawsRegulations/identifyOrAssessment', params, true)
}

// 全流程-法律法规-编辑
export function lawsRegulationsEdit(params) {
  return axios.post('/lawsRegulations/update', params, true)
}

// 全流程-法律法规-新增
export function lawsRegulationsAdd(params) {
  return axios.post('/lawsRegulations/save', params, true)
}

// 法律法规 - 基础库列表
export function lawsBaseList(params) {
  return axios.get('/basicsLaw/list_all', params, true)
}

// 法律法规 - 基础库新增
export function lawsBaseAdd(params) {
  return axios.post('/basicsLaw/save', params, true)
}

// 法律法规 - 基础库编辑
export function lawsBaseEdit(params) {
  return axios.post('/basicsLaw/update', params, true)
}

// 法律法规 - 基础库删除
export function lawsBaseDelete(params) {
  return axios.post(`/basicsLaw/delete/${params}`, true)
}

// 全流程-资源管理-资源类型保存
export function resourceTypeSave(params) {
  return axios.post('/datamanagertype/save', params, true)
}

// 全流程-资源管理-获取所有资源类型
export function resourceGetType(params) {
  return axios.get('/datamanagertype/getAll', params, true)
}

// 全流程-资源管理-资源类型删除
export function resourceTypeRemove(params) {
  return axios.delete(`/datamanagertype/delete/${params}`, true)
}

// 全流程-资源管理-编辑资源类型的名字
export function resourceTypeEdit(params) {
  return axios.post('/datamanagertype/update', params, true)
}

// 全流程-资源管理-获取某个类型下面的表格数据
export function resourceTableList(params) {
  return axios.get('/datamanage/list_all', params, true)
}

// 全流程-资源管理-添加某个标签下面的表格数据
export function resourceAddTable(params) {
  return axios.post('/datamanage/save', params, true)
}

// 全流程-资源管理-删除某个标签下面的表格数据
export function resourceDeleteTable(params) {
  return axios.delete(`/datamanage/delete/${params}`, true)
}

// 全流程-资源管理-编辑表格数据
export function resourceEditTable(params) {
  return axios.post(`/datamanage/update`, params, true)
}

// 全流程-作业管理-作业证新增-获取作业人数据（有作业证书的）
// export function getWorkerSelect(params) {
//   return axios.get('/businessManagement/userManagement/getUserInCertificate', params, true)
// }
export function getWorkerSelect(params) {
  return axios.get('/employee/getEmployeeInCertificate', params, true)
}

// 获取员工的数据
export function getStaffList(params) {
  return axios.get('/employee/getAll', params, true)
}

export function getEmployeeById(params) {
  return axios.get(`/employee/getById/${params}`, true)
}

// 全流程-作业管理-作业证新增-查询作业单位(承包商白名单)
export function getApplicantSelect(params) {
  return axios.get('/contractorInfo/listContrName', params, true)
}

// 全流程-作业管理-信息统计
export function getWorkInfo(params) {
  return axios.post('/workPermit/getWorkInfo', params, true)
 //return axios.get('/workPermit/qualifiedStatistics', params, true)
}

// 作业管理 - 作业票列表
export function getWorkPermitList(params) {
  return axios.post('/workPermit/list_all', params, false)
}

export function qualifiedStatistics(params) {
  //return axios.post('/workPermit/getWorkInfo', params, true)
  return axios.get('/workPermit/qualifiedStatistics', params, true)
}
// 作业管理 查询作业类型
export function getWorkType(params) {
  return axios.post('/certificateType/all_list', params, true)
}

// 作业管理 - 根据申请单位和作业证类型查询作业人
export function getWorkerByApplica(params) {
  return axios.get('/employee/getEmployeeInCertificate', params, true)
}

// 作业管理 - 作业详情
export function getWorkDetail(params) {
  return axios.post('/workPermit/info', params, false)
}

// 获取绑定了用户的员工
export function getEmpBindUser(params) {
  return axios.get('/employee/getEmpIfBindUser', params, true)
}

// 作业管理-动火人
export function getPlayFirerList(params) {
  return axios.get('/certificate/getCertificateEmpByContractorId', params, true)
}

// 全流程-作业管理-复核
export function submitToReview(params) {
  return axios.post('/workPermit/qualified', params, false)
}

// 作业管理 - 验收
export function workPermitYS(params) {
  return axios.post('/workPermit/acceptance', params, false)
}

// 全流程-变更管理-变更列表-点击审批的时候的接口
export function getSpDetail(params) {
  return axios.get(`/modifyform/find/${params}`, true)
}

// 全流程-变更管理-变更列表-提交审批
export function submitSpA(params) {
  return axios.post(`/modifyform/audit`, params, true)
}

// 全流程-变更管理-变更列表-回退审批
export function backScroll(params) {
  return axios.post(`/modifyform/auditGoBack`, params, true)
}

// 获取企业信息
export function getComponent(params) {
  return axios.get('/companybaseinfo/list_all', params, true)
}

// 添加化学品信息
export function addChemical(params) {
  return axios.post('/chemical/save', params, true)
}

// 查询化学品列表
export function getChemicalList(params) {
  return axios.get('/chemical/list_all', params, true)
}

// 查询化学品详情
export function getChemicalDetail(params) {
  return axios.get(`/chemical/info/${params}`, true)
}

// 编辑化学品信息
export function editChemical(params) {
  return axios.post(`/chemical/update`, params , true)
}

// 删除某一条化学品
export function deleteChemical(params) {
  return axios.delete(`/chemical/delete/${params}` , true)
}

// 批量删除化学品
export function deleteBatch1(params) {
  return axios.post(`/chemical/deleteBatch`, params , true)
}

// 化学品入库
export function hemicalIn(params) {
  return axios.post(`/chemical/rk`, params, true)
}

// 化学品出库
export function chemicalOut(params) {
  return axios.post(`/chemical/ck`, params, true)
}

// 设备设施管理-设备台账-获取分类
export function equipmentType(params) {
  return axios.get('/equipmentType/list_all', params, true)
}

// 设备台账-新增分类
export function addType(params) {
  return axios.post('/equipmentType/save', params, true)
}

// 设备台账-编辑分类
export function editType(params) {
  return axios.post('/equipmentType/update', params, true)
}

// 设备台账-删除分类
export function deleteType(params) {
  return axios.post(`/equipmentType/delete/${params}`, true)
}

// 设备台账-获取某个分类的列表
export function getTypeList(params) {
  return axios.get(`/equipment/list_all`, params, true)
}

// 设备台账-检查新增
export function examineAdd(params) {
  return axios.post(`/equipmentExamineRecord/save`, params, false)
}

// 设备台账-检测新增
export function detectionAdd(params) {
  return axios.post(`/equipmentDetectionRecord/save`, params, false)
}

// 设备台账-操作新增
export function operationAdd(params) {
  return axios.post(`/equipmentOperationRecord/save`, params, false)
}

// 设备台账-检查记录
export function equipmentExamineList(params) {
  return axios.get(`/equipmentExamineRecord/list_all`, params, true)
}

// 设备台账-检测记录
export function detectionList(params) {
  return axios.get(`/equipmentDetectionRecord/list_all`, params, true)
}

// 设备台账-操作记录
export function operationList(params) {
  return axios.get(`/equipmentOperationRecord/list_all`, params, true)
}

// 设备台账 - 打印
export function equipmentPrintf(params) {
  return axios.post(`/equipment/print`, params, false)
}

// 获取人员(用户)列表接口
export function getAlluser(params) {
  return axios.get('/businessManagement/userManagement/getAllUser', params, true)
}

// 获取所有部门
export function getAllDepartment(params) {
  return axios.get('/businessManagement/departmentManagement/getAll', params, true)
}

// 获取某一个部门下面的人员
export function getDepartUser(params) {
  return axios.post('/employee/findEmpByDepId', params, true);
}
export function getEmp(params) {
  return axios.post('/employee/findEmpByTypeId', params, true);
}
// 获取岗位列表
export function getPostList(params) {
  return axios.get('/job/list_all', params, true)
}
export function getJobList(params) {
  return axios.get('/job/getJobList', params, true)
}
// 岗位新增
export function addPost(params) {
  return axios.post('/job/save', params, true)
}

// 岗位编辑
export function editPost(params) {
  return axios.post('/job/update', params, true)
}

// 删除岗位
export function deletePost(params) {
  return axios.post(`/job/delete/${params}`, true)
}

// 设备台账-新增设备
export function addEquipment(params) {
  return axios.post('/equipment/save', params, true)
}

// 设备台账-编辑设备
export function editEquipment(params) {
  return axios.post('/equipment/update', params, true)
}

// 设备台账-删除设备
export function deleteEquipment(params) {
  return axios.post(`/equipment/delete/${params}`, true)
}

// 设备台账-详情接口
export function equipmentInfo(params) {
  return axios.get(`/equipment/info/${params}`, true)
}

// 设备台账-巡检记录接口
export function equipmentXjRecord(params) {
  return axios.get(`/equipment/inspection_record`, params, true)
}

// 设备台账-保养维修记录接口
export function equipmentByRecord(params) {
  return axios.get(`/equipment/keep_maintain_list`, params, true)
}

// 设备台账-统计
export function equipmentStatistics(params) {
  return axios.get(`/equipment/statistics`, params, true)
}

// 保养维修记录-获取列表
export function getEquipmentMaintainList(params) {
  return axios.get(`/equipment/keep_maintain_list`, params, true)
}

// 维修记录-新增
export function addEquipmentMaintain(params) {
  return axios.post(`/equipmentMaintain/save`, params, true)
}

// 维修记录-修改
export function editEquipmentMaintain(params) {
  return axios.post(`/equipmentMaintain/update`, params, true)
}

// 维修记录-删除
export function deleteWxRecord(params) {
  return axios.post(`/equipmentMaintain/delete/${params}`, true)
}

// 保养记录-删除
export function deleteByRecord(params) {
  return axios.post(`/equipmentKeep/delete/${params}`, true)
}

// 保养维修记录-详情
export function getKeepMaintainDetails(params) {
  return axios.get('/equipment/getKeepMaintainDetails', params, true)
}

// 保养记录-新增
export function addKeepMaintain(params) {
  return axios.post('/equipmentKeep/save', params, true)
}

// 保养记录-编辑
export function editKeepMaintain(params) {
  return axios.post('/equipmentKeep/update', params, true)
}

// 保养维修完成按钮
export function finishMaintain(params) {
  return axios.get('/equipment/completeKeepMaintain', params, true)
}

// 变更验收-审核-详情
export function proAcceptexamineDetail(params) {
  return axios.get(`/modifyAccepting/find/${params}`, true)
}

// 变更验收-提交审核
export function proAcceptexamine(params) {
  return axios.post(`/modifyAccepting/audit`, params, true)
}

// 变更验收-回滚
export function proAcceptBackScroll(params) {
  return axios.post(`/modifyAccepting/auditGoBack`, params, true)
}

// 人员管理-人员详情(获取基本信息)
export function getPersonDetail(params) {
  return axios.get('/employee/mapDetail', params, true)
}

// 人员管理-人员详情(获取三卡信息)
export function getPersonDetailNew(params) {
  return axios.get(`/employee/getEmp3Card/${params}`, true)
}

// 人员管理-人员培训记录/考试
export function getPersonPx(params) {
  return axios.get('/employee/empRecordAndQuestionnaire', params, false)
}

// 人员管理-人员个人证书
export function getPersonZs(params) {
  return axios.get('/certificate/getByEmpId', params, false)
}

// 人员培训-人员考试记录
// export function getPersonKs(params) {
//   return axios.get('/examrecord/getByEmpId', params, false)
// }

// 人员管理-人员应急卡详情
export function getPersonYj(params) {
  return axios.get('/exception/getByEmergencyId', params, false)
}

// 主要负责人 - 新增
export function responsiblePersonsAdd(params) {
  return axios.post('/responsiblePersons/save', params, true);
}

// 主要负责人 - 编辑
export function responsiblePersonsUpdate(params) {
  return axios.post('/responsiblePersons/update', params, true);
}

// 主要负责人 - 列表
export function responsiblePersonsList(params) {
  return axios.post('/responsiblePersons/responsiblePersonsList', params, true);
}

// 主要负责人删除
export function responsiblePersonsDelete(params) {
  return axios.post(`/responsiblePersons/delete/${params}`, true);
}

// 主要负责人批量删除
export function responsiblePersonsDeleteBatch(params) {
  return axios.post('responsiblePersons/deleteBatch', params, true);
}

// 两单管理-危险因素排查辨识清单
export function getDangerISPcList(params) {
  return axios.get('/harmfulfactorsinvestigation/list_all', params, true)
}


// 教育培训-培训记录
export function getTrainRecordList(params) {
  return axios.post('/cultivateHistory/list_all', params, true)
}

// 删除培训记录
export function delTrainRecord(params) {
  return axios.post(`/cultivateHistory/deleteEmp/${params}`, true)
}

// 两单管理-新增-根据区域id查询报警器数据
export function getAlarmByReginId(params) {
  return axios.get(`/channel/getByDangerId/${params}`, true)
}

// 获取报警记录
export function getAlarmRecordList(params) {
  return axios.get('/channelrecord/getByDangerIds', params, true)
}

// 风险点详情-获取报警记录
export function getPointAlartRecord(params) {
  return axios.get('/alertData/getByDangerId', params, true)
}

// 目标责任管理-考核
export function responsibilityKh(params) {
  return axios.post('/responsibilityAssess/save', params, true)
}

// 目标责任管理-详情
export function responsibilityDetail(params) {
  return axios.get(`/responsibilitybook/info/${params}`, true)
}

// 目标责任管理-抽屉表格-删除
export function responsibilityDelete(params) {
  return axios.post(`/responsibilityAssess/delete/${params}`, true)
}

// 物资管理-获取分类列表
export function getClassList(params) {
  return axios.get('/supplies/list_all', params, true)
}

// 物资管理-新增分类
export function addClassList(params) {
  return axios.post('/supplies/save', params, false)
}

// 物资管理-编辑分类
export function editClassList(params) {
  return axios.post('/supplies/update', params, false)
}

// 物资管理-删除分类
export function deleteClassList(params) {
  return axios.post(`/supplies/delete/${params}`, false)
}

// 可燃有毒气体-报警分析- 图表数据
export function getBjfxData(params) {
  return axios.post('/channelrecord/findChannelRecordList', params, true)
}

// 可燃有毒气体-报警记录 - 核实
export function alarmRecordHS(params) {
  return axios.post('/alertData/verify', params, true)
}

// 可燃有毒气体-报警记录 - 处置
export function alarmRecordCZ(params) {
  return axios.post('/alertData/dispose', params, true)
}

// 可燃有毒气体-报警记录 - 复查
export function alarmRecordFC(params) {
  return axios.post('/alertData/recheck', params, true)
}

// 可燃有毒气体-设备管理-上下线
export function switchOnOff(params) {
  return axios.post(`/channel/onOFF/${params}`, true)
}

// 证书管理-作业证类型查询
export function getCertificateType(params) {
  return axios.post('/certificateType/all_list', params, true)
}

// 证书管理-复核
export function certificateFH(params) {
  return axios.post('/certificateReCheck/save', params, true)
}

// 证书详情
export function certificateDetail(params) {
  return axios.get(`/certificate/info/${params}`, true)
}

// 证书详情 --复核记录删除
export function deteleReview(params) {
  return axios.post(`/certificateReCheck/delete/${params}`, true)
}

// 进出管理 - 人员进出列表
export function peopleInOutList(params) {
  return axios.post('/attendanceRecord/findBySearch', params, true)
}

// 进出- 人员新增
export function addPeopleInOut(params) {
  return axios.post('/attendanceRecord/save', params, true)
}

// 进出- 人员出场
export function peopleOut(params) {
  return axios.post('/attendanceRecord/goOut', params, true)
}

// 进出- 删除人员记录
export function deletePeopleInOut(params) {
  return axios.post(`/attendanceRecord/delete/${params}`, true)
}

// 进出 - 车辆进出列表
export function vehicleInOutList(params) {
  return axios.post('/vehicleRecord/findVehicleRecord', params, true)
}

// 进出 - 车辆出场
export function vehicleOut(params) {
  return axios.post('/vehicleRecord/app/goOut', params, true);
}

// 进出 - 车辆记录删除
export function deleteVehicleRecord(params) {
  return axios.post(`/vehicleRecord/delete/${params}`, true)
}

// 进出 - 车辆记录新增
export function addvehicleRecord(params) {
  return axios.post('/vehicleRecord/save', params, true)
}

// 目标管理 - 考核标准新增
export function AddStandard(params) {
  return axios.post('/objectiveExaminationCriterion/save', params, true)
}

// 编辑
export function EditStandard(params) {
  return axios.post('/objectiveExaminationCriterion/update', params, true)
}

// 删除
export function deleteStandard(params) {
  return axios.post(`/objectiveExaminationCriterion/delete/${params}`, true)
}

// 目标管理  -  考核标准列表
export function getStandardList(params) {
  return axios.get('/objectiveExaminationCriterion/list_all', params, true)
}

// 目标管理 - 考核标准详情信息
export function standardDetail(params) {
  return axios.get(`/objectiveExaminationCriterion/info/${params}`, true)
}

// 考核标准审核
export function examineStandard(params) {
  return axios.post('/objectiveExaminationCriterion/audit', params, true);
}

// 目标管理- 目标列表
export function getGoalList(params) {
  return axios.get('/objectiveIndicator/list_all', params, true)
}

// 目标管理 - 目标新增
export function addGoal(params) {
  return axios.post('/objectiveIndicator/save', params, true)
}

// 目标编辑
export function editGoal(params) {
  return axios.post('/objectiveIndicator/update', params, true)
}

// 目标删除
export function deleteGoal(params) {
  return axios.post(`/objectiveIndicator/delete/${params}`, true)
}

// 目标详情
export function goalInfo(params) {
  return axios.get(`/objectiveIndicator/info/${params}`, true)
}

// 目标审核
export function examineGoal(params) {
  return axios.post('/objectiveIndicator/audit', params, true)
}

// 目标拆分列表
export function goalSplitList(params) {
  return axios.get('/objectiveIndicatorChild/list_all', params, true)
}

// 目标拆分 - 删除
export function deleteGoalSplit(params) {
  return axios.post(`/objectiveIndicatorChild/delete/${params}`, true)
}

// 拆分新增 选择编号后调的接口
export function getGoalAddData(params) {
  return axios.post('/objectiveIndicatorChild/decompose', params, true)
}

// 拆分保存
export function goalSplitAdd(params) {
  return axios.post('/objectiveIndicatorChild/save', params, true)
}

// 拆分编辑
export function editSplit(params) {
  return axios.post('/objectiveIndicatorChild/update', params, true)
}

// 拆分详情接口
export function splitInfo(params) {
  return axios.get(`/objectiveIndicatorChild/info/${params}`, true)
}

// 拆分审核
export function examineSplit(params) {
  return axios.post('/objectiveIndicatorChild/audit', params, true)
}

// 目标管理 - 考核管理
export function getExamineList(params) {
  return axios.get('/objectiveExamination/list_all', params, true)
}

// 目标拆分跳转转到目标考核新增页面  调取的接口
export function findExaminedMdg(params) {
  return axios.post('/objectiveExamination/findExaminedMsg', params, true)
}

// 目标考核保存
export function checkTargetSave(params) {
  return axios.post('/objectiveExamination/save', params, true)
}

// 目标考核 - 修改
export function checkTargetUpdate(params) {
  return axios.post('/objectiveExamination/update', params, true)
}

// 目标考核 - 目标考核详情接口
export function checkTargetDetail(params) {
  return axios.get(`/objectiveExamination/info/${params}`, true)
}

// 目标考核 - 审批
export function examineTarget(params) {
  return axios.post('/objectiveExamination/audit', params, true)
}

// 目标整改 - 表格
export function rectifyTargetList(params) {
  return axios.get('/objectiveExaminationAbarbeitung/list_all', params, true)
}

// 进入目标整改新增页面的时候 用考核列表的id查询详情
export function getRectifyAddInfo(params) {
  return axios.post('/objectiveExaminationAbarbeitung/rectificationPlan', params, true)
}

// 整改新增
export function rectifyTargetSave(params) {
  return axios.post('/objectiveExaminationAbarbeitung/save', params, true)
}

// 编辑
export function rectifyTargetUpdate(params) {
  return axios.post('/objectiveExaminationAbarbeitung/update', params, true)
}

// 整改详情
export function rectifyDetail(params) {
  return axios.get(`/objectiveExaminationAbarbeitung/info/${params}`, true)
}

// 整改复核
export function rectifyReview(params) {
  return axios.post('/objectiveExaminationAbarbeitung/recheck', params, true)
}

// 目标考核统计
export function getGoalStatistics(params) {
  return axios.get('/objectiveIndicatorChild/statistics', params, true)
}

// 责任管理 - 岗位责任书列表
export function getResponseBookList(params) {
  return axios.get('/responsibleJob/list_all', params, true)
}

// 责任管理 - 岗位责任书新增
export function responseBookAdd(params) {
  return axios.post('/responsibleJob/save', params, true)
}

// 责任管理 - 岗位责任书编辑
export function responseBookEdit(params) {
  return axios.post('/responsibleJob/update', params, true)
}

// 责任管理 - 岗位责任列表删除
export function responseBookDelete(params) {
  return axios.post(`/responsibleJob/delete/${params}`, true)
}

// 岗位责任书详情
export function responseBookInfo(params) {
  return axios.get(`/responsibleJob/info/${params}`, true)
}

// 岗位责任书审核
export function responseBookExamine(params) {
  return axios.post('/responsibleJob/audit', params, true);
}

// 个人责任书列表
export function getResponsePersonalList(params) {
  return axios.get('/responsibleEmp/list_all', params, true)
}

// 个人责任书删除
export function responsibleEmpDelete(params) {
  return axios.post(`/responsibleEmp/delete/${params}`, true)
}

// 根据岗位id查询员工列表
export function getEmpListByJobId(params) {
  return axios.post('/employee/findEmpByJodId', params, true)
}

// 员工责任书新增
export function personalResponseAdd(params) {
  return axios.post('/responsibleEmp/save', params, true)
}

// 员工责任书编辑
export function personalResponseEdit(params) {
  return axios.post('/responsibleEmp/update', params, true)
}

// 员工责任书详情
export function personalResponseInfo(params) {
  return axios.get(`/responsibleEmp/info/${params}`, true)
}

// 员工责任书签字
export function signPersonalResPonse(params) {
  return axios.post('/responsibleEmp/sign', params, true)
}

// 员工责任书考核
export function examinePersonResponse(params) {
  return axios.post('/responsibilityAssess/save', params, true)
}

// 个人责任书---一键生成
export function generatePersonalRes(params) {
  return axios.post('/responsibleEmp/batchCreateRes', params, true)
}

// 三卡管理 --- 承诺卡新增
export function addPromiseCard(params) {
  return axios.post('/promisecard/save', params, true)
}

// 三卡管理 - 承诺卡编辑
export function updatePromiseCard(params) {
  return axios.post('/promisecard/update', params, true)
}

// 三卡管理 - 应急卡新增
export function addEmergeCard(params) {
  return axios.post('/emergencycard/save', params, true)
}

// 应急卡编辑
export function updateEmergeCard(params) {
  return axios.post('/emergencycard/update', params, true)
}

// 三卡管理 --  应知卡新增
export function addShouldKonwn(params) {
  return axios.post('/shouldknowcard/save', params, true)
}

// 应知卡编辑
export function updateShouldKnown(params) {
  return axios.post('/shouldknowcard/update', params, true)
}

// 警示牌管理 - 列表
export function dangerSignList(params) {
  return axios.get('/warningSign/list_all', params, true)
}

// 警示牌管理 - 新增
export function dangerSignAdd(params) {
  return axios.post('/warningSign/save', params, true)
}

// 警示牌管理 - 编辑
export function dangerSignUpdate(params) {
  return axios.post('/warningSign/update', params, true)
}

// 警示牌管理 - 删除
export function dangerSigndelete(params) {
  return axios.post(`/warningSign/delete/${params}`, true)
}

// 生产原材料 - 列表
export function rawMaterialList(params) {
  return axios.get('/rawMaterial/list_all', params, true)
}

// 生产原材料 - 新增
export function rawMaterialAdd(params) {
  return axios.post('/rawMaterial/save', params, true)
}

// 生产原材料 - 编辑
export function rawMaterialEdit(params) {
  return axios.post('/rawMaterial/update', params, true)
}

// 生产原材料 - 删除
export function rawMaterialDelete(params) {
  return axios.post(`/rawMaterial/delete/${params}`, true)
}

// 培训资料 - 新增
export function trainMaterialsAdd(params) {
  return axios.post('/trainMaterials/save', params, false)
}

// 培训资料 - 编辑
export function trainMaterialsEdit(params) {
  return axios.post('/trainMaterials/update', params, false);
}

// 培训资料 - 列表
export function trainMaterialsList(params) {
  return axios.get('/trainMaterials/list_all', params, true);
}

// 培训 - 新增
export function cultivateAdd(params) {
  return axios.post('/cultivate/save', params, false);
}

// 培训 - 编辑
export function cultivateEdit(params) {
  return axios.post('/cultivate/update', params, false);
}

// 培训 - 详情
export function cultivateInfo(params) {
  return axios.get(`/cultivate/info/${params}`)
}

// 培训 - 签到、上传照片
export function trainingSign(params) {
  return axios.post('/cultivate/updateSignInFileOrSitePhoto', params, true);
}

// 安全活动信息表
export function safetyActivityInfoList(params) {
  return axios.get('/securityActivities/list_all', params, true)
}

// 安全活动信息表 - 新增
export function safetyActivityInfoAdd(params) {
  return axios.post('/securityActivities/save', params, true)
}

// 安全活动信息表 - 编辑
export function safetyActivityInfoEdit(params) {
  return axios.post('/securityActivities/update', params, true)
}

// 安全活动信息表 - 删除
export function safetyActivityInfoDelete(params) {
  return axios.post(`/securityActivities/delete/${params}`, true)
}

// 工艺流程 - 新增
export function flowChartAdd(params) {
  return axios.post('/technologicalProcessDiagram/save', params, true)
}

// 工艺流程 - 编辑
export function flowChartEdit(params) {
  return axios.post('/technologicalProcessDiagram/update', params, true)
}

// 工艺流程 - 删除
export function flowChartDelete(params) {
  return axios.post(`/technologicalProcessDiagram/delete/${params}`, true)
}

// 工艺流程 - 列表
export function flowChartList(params) {
  return axios.get(`/technologicalProcessDiagram/list_all`, params, true)
}

// 工艺信息 - 列表
export function processInfoList(params) {
  return axios.get('/technologyInfo/list_all', params, true)
}

// 工艺信息 - 新增
export function processInfoAdd(params) {
  return axios.post('/technologyInfo/save', params, true)
}

// 工艺信息 - 编辑
export function processInfoEdit(params) {
  return axios.post('/technologyInfo/update', params, true)
}

// 工艺信息 - 删除
export function processInfoDelete(params) {
  return axios.post(`/technologyInfo/delete/${params}`, true)
}

// 公用工程 - 新增
export function pubEngineeringAdd(params) {
  return axios.post('/utilities/save', params, true)
}

// 公用工程 - 编辑
export function pubEngineeringEdit(params) {
  return axios.post('/utilities/update', params, true)
}

// 公用工程 - 列表
export function pubEngineeringList(params) {
  return axios.get('/utilities/list_all', params, true)
}

// 公用工程 - 删除
export function pubEngineeringDelete(params) {
  return axios.post(`/utilities/delete/${params}`, true)
}

// 周边环境信息 - 新增
export function evnInfoAdd(params) {
  return axios.post('/surroundings/save', params, true)
}

// 周边环境信息 - 编辑
export function evnInfoEdit(params) {
  return axios.post('/surroundings/update', params, true)
}

// 周边环境信息 - 列表
export function evnInfoList(params) {
  return axios.get('/surroundings/list_all', params, true)
}

// 周边环境信息 - 删除
export function evnInfoDelete(params) {
  return axios.post(`/surroundings/delete/${params}`, true)
}

// 承包商抽屉里面的接口
// 承包商施工管理 - 新增
export function contractorConManagerAdd(params) {
  return axios.post('/contractorsConstructionSupervision/save', params, true)
}

// 承包商施工管理 - 编辑
export function contractorConManagerEdit(params) {
  return axios.post('/contractorsConstructionSupervision/update', params, true)
}

// 承包商施工管理 - 列表
export function contractorConManagerList(params) {
  return axios.get('/contractorsConstructionSupervision/list_all', params, true)
}

// 承包商施工管理 - 删除
export function contractorConManagerDelete(params) {
  return axios.post(`/contractorsConstructionSupervision/delete/${params}`, true)
}

// 承包商评定管理 - 新增
export function contractorEvaManagerAdd(params) {
  return axios.post('/contractorsAssessManagement/save', params, true)
}

// 承包商评定管理 - 编辑
export function contractorEvaManagerEdit(params) {
  return axios.post('/contractorsAssessManagement/update', params, true)
}

// 承包商评定管理 - 列表
export function contractorEvaManagerList(params) {
  return axios.get('/contractorsAssessManagement/list_all', params, true)
}

// 承包商评定管理 - 删除
export function contractorEvaManagerDelete(params) {
  return axios.post(`/contractorsAssessManagement/delete/${params}`, true)
}

// 承包商违章记录 - 新增
export function conViolationRecordAdd(params) {
  return axios.post('/contractorsDelr/save', params, true)
}

// 承包商违章记录 - 编辑
export function conViolationRecordEdit(params) {
  return axios.post('/contractorsDelr/update', params, true)
}

// 承包商违章记录 - 列表
export function conViolationRecordList(params) {
  return axios.get('/contractorsDelr/list_all', params, true)
}

// 承包商违章记录 - 删除
export function conViolationRecordDelete(params) {
  return axios.post(`/contractorsDelr/delete/${params}`, true)
}


// 供应商管理 - 新增
export function supplierManagerAdd(params) {
  return axios.post('/supplierManagment/save', params, true)
}

// 供应商管理 - 编辑
export function supplierManagerEdit(params) {
  return axios.post('/supplierManagment/update', params, true)
}

// 供应商管理 - 列表
export function supplierManagerList(params) {
  return axios.get('/supplierManagment/list_all', params, true)
}

// 供应商管理 - 删除
export function supplierManagerDelete(params) {
  return axios.post(`/supplierManagment/delete/${params}`, true)
}

// 应急队伍管理 - 列表
export function meetEmerRanksList(params) {
  return axios.get('/emergencyTeam/list_all', params, true)
}

// 应急队伍管理 - 新增
export function meetEmerRanksAdd(params) {
  return axios.post('/emergencyTeam/save', params, true)
}

// 应急队伍管理 - 编辑
export function meetEmerRanksEdit(params) {
  return axios.post('/emergencyTeam/update', params, true)
}

// 应急队伍管理 - 删除
export function meetEmerRanksDelete(params) {
  return axios.post(`/emergencyTeam/delete/${params}`, true)
}

// 应急队伍管理 - 详情
export function meetEmerRanksDetail(params) {
  return axios.get(`/emergencyTeam/info/${params}`, true)
}

// 应急物资 - 添加保养维修记录
export function addMasterialRecord(params) {
  return axios.post('/materialsKeepMaintain/save', params, false)
}

// 应急物资 - 编辑保养维修记录
export function editMasterialRecord(params) {
  return axios.post('/materialsKeepMaintain/save', params, false)
}

// 应急物资 - 删除保养维修记录
export function deleteMasterialRecord(params) {
  return axios.post(`/materialsKeepMaintain/delete/${params}`, true)
}

// 应急物资 - 详情
export function materialDetail(params) {
  return axios.get(`/materials/info/${params}`, true)
}

// 工伤申报 - 新增
export function inJuryONJobAdd(params) {
  return axios.post('/occupationalInjuryDeclaration/save', params, true)
}

// 工伤申报 - 编辑
export function inJuryONJobEdit(params) {
  return axios.post('/occupationalInjuryDeclaration/update', params, true)
}

// 工伤申报 - 列表
export function inJuryONJobList(params) {
  return axios.get('/occupationalInjuryDeclaration/list_all', params, true)
}

// 工伤申报 - 删除
export function inJuryONJobDelete(params) {
  return axios.post(`/occupationalInjuryDeclaration/delete/${params}`, true)
}

// 事故快报列表接口
export function accidentBulletin(params) {
  return axios.get('/accidentBulletin/list_all', params, true)
}

// 考试管理 - 新增考试 - 随机抽题
export function randomExam(params) {
  return axios.post('/questionnaire/randomlySelectedTopic', params, true)
}

// 考试管理 - 考试详情
export function getExamDetail(params) {
  return axios.get(`/examrecord/info/${params}`, true)
}

// 考试管理 - 个人答题详情
export function getUserExamDetail(params) {
  return axios.get(`/examrecord/examInfo/${params}`, true)
}

// 项目三同时 - 列表
export function getProject3List(params) {
  return axios.get('/projectThreeMeanWhile/list_all', params, true)
}

// 项目三同时 - 新增
export function addProject3(params) {
  return axios.post('/projectThreeMeanWhile/save', params, true)
}

// 项目三同时 - 编辑
export function editProject3(params) {
  return axios.post('/projectThreeMeanWhile/update', params, true)
}

// 项目三同时 - 删除
export function deleteProject3(params) {
  return axios.post(`/projectThreeMeanWhile/delete/${params}`, true)
}

// 获取权限人员列表
export function getPermisssionEmpList(params) {
  return axios.get('/employee/findHavePermissionEmp', params, true)
}

// 获取演练计划详情
export function getDrillEva(params) {
  return axios.get(`/drillingPlan/info/${params}`, true)
}

// 演练计划评价保存
export function DrillEvaSave(params) {
  return axios.post('/drillingAssess/save', params, false)
}

// 演练计划详情接口
export function DrillEvaDetail(params) {
  return axios.get('/drillingAssess/info', params, true)
}

// 连接信息接口 - 列表
export function connectInfoList(params) {
  return axios.get('/eqmBasicInfo/list_all', params, true)
}

// 连接信息 - 新增
export function connectInfoAdd(params) {
  return axios.post('/eqmBasicInfo/save', params, true)
}

// 连接信息 - 编辑
export function connectInfoEdit(params) {
  return axios.post('/eqmBasicInfo/update', params, true)
}

// 连接信息 - 删除
export function connectInfoDelete(params) {
  return axios.post(`/eqmBasicInfo/delete/${params}`, true)
}

// 采集信息 - 树形结构接口
export function channelTree(params) {
  return axios.get('/channelNew/tree', params, true)
}

// 采集信息 - 通道列表
export function collectInfoList(params) {
  return axios.get('/channelNew/list_all', params, true)
}

// 采集信息 - 通道新增
export function collectInfoAdd(params) {
  return axios.post('/channelNew/save', params, true)
}

// 采集信息 - 通道编辑
export function collectInfoEdit(params) {
  return axios.post('/channelNew/update', params, true)
}

// 采集信息 - 通道删除
export function collectInfoDelete(params) {
  return axios.post(`/channelNew/delete/${params}`, true)
}

// 采集信息 - 通过通道id查设备
export function collectEquipmentList(params) {
  return axios.get('/device/list_all', params, true)
}

// 采集信息 - 通过设备id查采集点
export function collectionPointList(params) {
  return axios.get('/dataCollectionPoint/list_all', params, true)
}

// 报警 - 历史数据折线图接口
export function findPointRecord(params) {
  return axios.post('/collectionData/findPointRecord', params, true)
}

// 采集信息 - 设备新增
export function collectEquipmentAdd(params) {
  return axios.post('/device/save', params, true)
}

// 采集信息 - 设备编辑
export function collectEquipmentEdit(params) {
  return axios.post('/device/update', params, true)
}

// 采集信息 - 设备删除
export function collectEquipmentDelete(params) {
  return axios.post(`/device/delete/${params}`, true)
}

// 采集信息 - 采集点新增
export function collectPointAdd(params) {
  return axios.post('/dataCollectionPoint/save', params, true)
}

// 采集信息 - 采集点编辑
export function collectPointEdit(params) {
  return axios.post('/dataCollectionPoint/update', params, true)
}

// 采集信息 - 采集点删除
export function collectPointDelete(params) {
  return axios.post(`/dataCollectionPoint/delete/${params}`, true)
}

// 采集信息 - 采集点详情
export function collectPointInfo(params) {
  return axios.get(`/dataCollectionPoint/info/${params}`, true)
}

// 获取视频监控报警
export function getNvrAlarmList(params) {
  return axios.get('/nvrAlarm/list_all', params, false);
}
// 获取排查任务超期报警
export function getTroubleshootOverdueList(params) {
  return axios.post('/troubleshoottask/list_all', params, false);
}
// 新增视频监控报警
export function nvrAlarmAdd(params) {
  return axios.post('/nvrAlarm/save', params, false);
}

// 编辑视频监控报警
export function nvrAlarmUpdate(params) {
  return axios.post('/nvrAlarm/update', params, false);
}

// 删除视频监控报警
export function nvrAlarmDelete(params) {
  return axios.post(`/nvrAlarm/delete/${params}`, true)
}
